import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class SchoolApi {
  getAllSchools(config) {
    return axios.get(BASE_URL + "/admin/school/schoolDetails", config)
  }

  getSchoolById(schoolCode, config) {
    return axios.get(`${BASE_URL}/admin/school/${schoolCode}`, config)
  }

  addSchool(data, config) {
    return axios.post(BASE_URL + "/admin/school/create", data, config)
  }

  updateSchool(data, config) {
    return axios.put(BASE_URL + "/admin/school/update", data, config)
  }

  deleteSchool(data, config) {
    return axios.delete(BASE_URL + "/admin/school/remove", {
      ...config,
      data: data
    })
  }

  updateSchoolStatus(payload, config) {
    return axios.put(
      BASE_URL + "/admin/school/update-status",
      payload,
      config
    )
  }

  uploadSchoolByExcel(formData, config) {
    return axios.post(
      BASE_URL + "/admin/school/uploadSchool",
      formData,
      config
    )
  }
}

export default new SchoolApi()
